import angular from 'angular';
import uiRouter from 'angular-ui-router';
import eventAddPageComponent from './eventAddPage.component';

let eventAddPageModule = angular.module('eventAddPage', [
  uiRouter
])

.component('eventAddPage', eventAddPageComponent)

.name;

export default eventAddPageModule;
